import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { API_URL } from '@/shared/constants/linksApi'

// ⚠️ Можно вынести в .env.local
const API_USER = process.env.API_USER || 'testuser'
const API_PASS = process.env.API_PASS || 'testbtpeel748'

const basicAuth =
  'Basic ' + Buffer.from(`${API_USER}:${API_PASS}`).toString('base64')

const generalApi = createApi({
  reducerPath: 'generalApi',
  baseQuery: fetchBaseQuery({
    baseUrl: API_URL,
    prepareHeaders: (headers) => {
      headers.set('Content-Type', 'application/json')
      headers.set('Authorization', basicAuth)
      return headers
    },
  }),
  endpoints: (builder) => ({
    getModulePage: builder.mutation({
      query: (path) => {
        const cutPath = path.length > 1 ? path : ''
        return {
          url: `/back/url/${cutPath}`,
          method: 'POST',
        }
      },
    }),
    getInformationPage: builder.mutation({
      query: (idPage) => ({
        url: '/back/information/one',
        method: 'POST',
        body: { id: idPage },
      }),
    }),
    productsCatalog: builder.mutation({
      query: () => ({
        url: '/back/product/hits',
        method: 'POST',
      }),
    }),
    newProductsCatalog: builder.mutation({
      query: () => ({
        url: '/back/product/new',
        method: 'POST',
      }),
    }),
    aboutText: builder.mutation({
      query: (textId) => ({
        url: '/back/setting/get/' + textId,
        method: 'POST',
      }),
    }),
    aboutSetting: builder.query({
      query: (textId) => ({
        url: '/back/setting/get/' + textId,
        method: 'GET',
      }),
    }),
    getAllNews: builder.mutation({
      query: () => ({
        url: '/back/news/main',
        method: 'POST',
      }),
    }),
    getSlidersHome: builder.query({
      query: () => ({
        url: '/back/banner/slider',
        method: 'GET',
      }),
    }),
    getVebinarsHome: builder.mutation({
      query: () => ({
        url: '/back/seminar/getSeminar',
        method: 'POST',
      }),
    }),
    signUpUserVebinar: builder.mutation({
      query: (body) => ({
        url: '/back/seminar/addUserSeminar',
        method: 'POST',
        body,
      }),
    }),
    getReviews: builder.mutation({
      query: () => ({
        url: '/back/review/get_three',
        method: 'POST',
      }),
    }),
    createReview: builder.mutation({
      query: (reviewData) => ({
        url: '/back/review/add',
        method: 'POST',
        body: reviewData,
      }),
    }),
    getCategories: builder.mutation({
      query: (categoryId) => ({
        url: '/back/category/list',
        method: 'POST',
        body: { parent_id: categoryId },
      }),
    }),
    getCategoryProducts: builder.mutation({
      query: (id) => ({
        url: '/back/product/list/',
        method: 'POST',
        body: { id },
      }),
    }),
    getAllProducts: builder.mutation({
      query: () => ({
        url: '/back/product/list',
        method: 'POST',
      }),
    }),
    getAboutText: builder.mutation({
      query: () => ({
        url: '/back/setting/get/1',
        method: 'POST',
      }),
    }),
  }),
})

export default generalApi
